import { Skeleton } from "../dashboard/Skeleton";

// Cold-load placeholder for the admin tables. Renders the real header
// labels inside the page's own table class so nothing reflows when data
// lands; with the SWR cache this only ever shows on a truly cold cache.

const WIDTHS: ReadonlyArray<string> = ["72%", "48%", "36%", "60%", "44%"];

type AdminTableSkeletonProps = {
  readonly headers: ReadonlyArray<string>;
  readonly rows?: number;
  readonly tableClassName: string;
};

export const AdminTableSkeleton = ({
  headers,
  rows = 8,
  tableClassName,
}: AdminTableSkeletonProps): JSX.Element => (
  <table className={tableClassName} aria-hidden>
    <thead>
      <tr>
        {headers.map((header, col) => (
          <th key={col}>{header}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {Array.from({ length: rows }, (_, row) => (
        <tr key={row}>
          {headers.map((_, col) => (
            <td key={col}>
              <Skeleton height="0.9375rem" width={WIDTHS[(row + col) % WIDTHS.length] ?? "50%"} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);
